import { render, staticRenderFns } from "./EbBanner.vue?vue&type=template&id=6e1ea6c6&scoped=true"
import script from "./EbBanner.vue?vue&type=script&lang=js"
export * from "./EbBanner.vue?vue&type=script&lang=js"
import style0 from "./EbBanner.vue?vue&type=style&index=0&id=6e1ea6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ea6c6",
  null
  
)

export default component.exports